import { Link as RouterLink, Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// components
import { APP_CONSTANTS } from '../URLConstants';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  let logoWidth;

  if (process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.BOM_CLIENT_IDENTIFIER) {
    logoWidth = 280;
  } else if (
    process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
  ) {
    logoWidth = 300;
  } else if (
    process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.IOB_CLIENT_IDENTIFIER
  ) {
    logoWidth = 300;
  } else {
    logoWidth = 150;
  }

  return (
    <>
      <HeaderStyle>
        {/* <Box component="img" src="/static/logo.svg" sx={{ width: 40 }} /> */}
        <Box
          component="img"
          src={process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_LOGO}
          sx={{ width: logoWidth }}
        />
      </HeaderStyle>
      <Outlet />
    </>
  );
}
